export default __webpack_public_path__ + "static/media/Print-10.31172408.svg";